import * as angular from 'angular';
import FdxFileMapsFaqModalController from './fdx-file-maps-faq-modal.controller';
import { MODULE_NAME } from '../../../../config/constants';

import './fdx-file-maps-faq-modal.styles.scss';

export const componentName = 'fdxFileMapsFaqModal';

angular.module(MODULE_NAME).component(componentName, {
	template: require('./fdx-file-maps-faq-modal.template.html'),
	controller: FdxFileMapsFaqModalController,
	bindings: {
		// from uibmodal
		close: '&',
		dismiss: '&',
		resolve: '<?'
	}
});
